import { Switch, Route } from 'react-router-dom';
import MainPage from '../pages/MainPage';

const MobileRutas = () => {
	return (
		<Switch>
			<Route path="/" exact component={MainPage}></Route>
		</Switch>
	)
};

export default MobileRutas;
